import Swiper, { Autoplay, FreeMode } from "swiper";

export default {
    init() {
        if (document.querySelector('.swiper-clients')) {
            Array.from(document.querySelectorAll('.swiper-clients'))
                .forEach(el => {
                    el.swiper = new Swiper(el, {
                        modules: [Autoplay, FreeMode],
                        autoplay: {
                            delay: 1,
                            disableOnInteraction: false,
                        },
                        speed: 4000,
                        slidesPerView: 'auto',
                        loop: true,
                        spaceBetween: 40,
                        freeMode: true,
                        grabCursor: true
                    });
                });
        }
    }
}
